import ReportPage from "components/Reports/Pages/SingleReport";

function DistributorReport() {
    return (
        <>
            <ReportPage isStandalone={false} />
        </>
    )
}

export default DistributorReport;
